import { render, staticRenderFns } from "./nav-buttons-info.vue?vue&type=template&id=c5d11b5c&scoped=true&"
import script from "./nav-buttons-info.vue?vue&type=script&lang=ts&"
export * from "./nav-buttons-info.vue?vue&type=script&lang=ts&"
import style0 from "./nav-buttons-info.vue?vue&type=style&index=0&id=c5d11b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d11b5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
